import { render } from "./AccountTypeSelect.vue?vue&type=template&id=5a14b968&ts=true"
import script from "./AccountTypeSelect.vue?vue&type=script&lang=ts"
export * from "./AccountTypeSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__